var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.pageLoading)?_c('div',{staticClass:"page-loading"},[_c('grid-loader',{attrs:{"loading":_vm.pageLoading,"color":_vm.colorPrimary,"size":"10px"}})],1):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }